// 管理仪表板布局组件
// 包含左侧固定导航栏 + 右侧内容区域

import { ResponsiveSidebarLayout } from '@/components/ui/responsive-shell'
import { AdminMobileNav, AdminSidebar } from '@/components/admin-sidebar/AdminSidebar'
import { Outlet } from 'react-router-dom'

export function AdminLayout() {
  return (
    <ResponsiveSidebarLayout
      sidebar={<AdminSidebar />}
      compactNavigation={<AdminMobileNav />}
      contentInnerClassName="2xl:pt-6"
      sidebarBreakpoint="2xl"
    >
      <Outlet />
    </ResponsiveSidebarLayout>
  )
}
